import { gsap } from 'gsap';
import React from 'react';

export const aniamtion = (
  ref: React.MutableRefObject<undefined>,
  index: number,
  oldIndex: number,
) => {
  gsap.from(ref.current, { x: index > oldIndex ? 100 : -100, duration: 0.5 });
};
